export default __webpack_public_path__ + "static/media/redvelvetcookie.aae4c524.png";